import ImageResult from './ImageResult';
import { ImageType } from './ImageResultProps';

export { ImageType };
export default ImageResult;
